import styled from "styled-components";
import { theme } from "styled-tools";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";

export const ContainerInput = styled.div<{ $size?: string }>`
  width: 100%;
  max-width: 650px;
  padding: 24px 0;
  box-sizing: border-box;
`;

export const ContainerText = styled.div`
  font-family: "Montserrat";
  margin-top: 5px;
  width: 100%;
  color: ${theme("Dark_Silver")};
  display: flex;
  flex-direction: row;
  align-content: center;
  &.hidden {
    display: none;
  }
`;

export const InputStyled = styled.input<{ $error?: boolean }>`
  cursor: pointer;
  border-radius: 12px;
  font-size: 18px;
  border-width: 1px;
  border-style: solid;
  color: ${theme("Dark_Silver")};
  border-color: ${(props) =>
    props.$error ? props.theme.Madder_Lake : props.theme.Silver_Sand};
  background: ${theme("White")};
  background-position: 3% 50%;
  margin-top: 8px;
  box-sizing: border-box;
  height: auto;
  padding: 16px;
  width: 100%;
`;

export const Label = styled.span`
  font-size: 18px;
  font-weight: bold;
  margin-left: 5px;
  text-align: left;

  ${mediaQuery[Screen.mobile]} {
    font-size: 16px;
  }
`;

export const Asterisk = styled.span`
  color: ${theme("Amaranth_Red")};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  font-family: "Montserrat";
  margin: 3px 0 0 -9px;
`;

export const Span = styled.span<{ $error?: boolean }>`
  margin-left: 4px;
  display: flex;
  flex-direction: row;
  position: relative;
  font-size: 16px;
  color: ${theme("Amaranth_Red")};
  width: 90%;
  height: 15px;
  text-align: left;
`;
